import { RichText } from '@sitecore-jss/sitecore-jss-react';
import React, { FC } from 'react';
import { TSummarySpecsProps } from '../../types/productModelsListing.types';

const SummarySpecs: FC<TSummarySpecsProps> = ({ summarySpecs }) => {
  return (
    <ul className="product-card__summary-specs">
      {summarySpecs.map((spec, index) => (
        <React.Fragment key={`summary-spec-${index}`}>
          {spec?.key && spec?.value && (
            <li className="product-card__summary-specs-item">
              <RichText tag='div' className="product-card__summary-specs-headline rich-text" field={{ value: spec?.key }} editable={false} />
              <RichText tag='div' className="product-card__summary-specs-value rich-text" field={{ value: spec?.value }} editable={false} />
            </li>
          )}
        </React.Fragment>
      ))}
    </ul>
  );
};

export default SummarySpecs;
